module.exports = __webpack_public_path__ + "static/media/btn_sheep.a1752310.png";